import { ru, enUS } from "date-fns/locale";
import { getCurrentLanguage } from "locales";

export function getDateFnsLocale() {
  return getCurrentLanguage() === "ru" ? ru : enUS;
}

export function getBcp47Locale(): string {
  return getCurrentLanguage() === "ru" ? "ru" : "en";
}

export function formatCallDurationLocalized(totalSec: number): string {
  const lang = getCurrentLanguage();
  const s = lang === "ru" ? "с" : "s";
  const m = lang === "ru" ? "м" : "m";
  const h = lang === "ru" ? "ч" : "h";
  if (totalSec < 60) return `${totalSec}${s}`;
  const minutes = Math.floor(totalSec / 60);
  const seconds = totalSec % 60;
  if (minutes < 60) return `${minutes}${m} ${seconds}${s}`;
  const hours = Math.floor(minutes / 60);
  return `${hours}${h} ${minutes % 60}${m}`;
}
